import React from 'react'
import {
  Button,
  Container,
  Link,
  ListContainer,
  TextBody,
  TextTitle,
  Css
} from '@pdrj/pmi-iqos-ds-react'
import { LazyImage } from '@pdrj/pmi-iqos-shared-react'
import SelectableOption from './selectable-option'
import { QuestTemplateTypes } from '../utils'

const QuestPreview = ({
  translations,
  questInfo,
  questState,
  cancelHandler,
  submitHandler,
  showHeader = false
}) => {
  const getState = component => {
    const state = questState.find(
      answer => (component && component.id) === (answer && answer.id)
    )
    return state || {}
  }

  const questDetailTemplates = {
    senryu: '/rsk2022/senryu'
  }

  const c = questInfo.components.find(
    component => component.type === QuestTemplateTypes.comment
  )
  const comment = questState.isPost ? questState.comment : getState(c).value
  const p = questInfo.components.find(
    component => component.type === QuestTemplateTypes.photo
  )
  const photo = questState.isPost ? questState.photo : getState(p).value

  const selects = questInfo.components.filter(
    component => component.type === QuestTemplateTypes.select
  )

  if (selects.length) {
    selects.forEach(s => {
      s.selections = []
      s.options.forEach(item => {
        const state = getState(item)
        if (state.value && state.date) {
          s.selections.push({
            image: item.image,
            value: item.label
          })
        }
      })
    })
  }

  const Post575Component = () => {
    const senryuComment =
      comment && comment.includes('\n') && comment.split('\n')
    return (
      <Container
        p="8"
        width="64"
        height="64"
        borderColor={Container.borderColors.primary}
        layout={Container.layouts.small}
        display={Container.displays.flex}
        flexDirection={Container.flexDirections.column}
        alignItems={Container.alignItemsValues.center}
        position={Container.positions.relative}>
        <Container
          position={Container.positions.absolute}
          t="3"
          r="3"
          b="3"
          l="3"
          display={Container.displays.flex}
          alignItems={Container.alignItemsValues.center}
          justifyContent={Container.justifyContentValues.center}>
          <LazyImage
            cover
            width="full"
            height="full"
            src={photo}
            alt={'comment-background'}
          />
        </Container>
        <Container zIndex="1">
          <Css
            s={{
              textOrientation: 'mixed',
              writingMode: 'vertical-rl'
            }}>
            {senryuComment.map((c, index) => (
              <TextBody key={index}>
                {c}
                <br />
              </TextBody>
            ))}
          </Css>
        </Container>
      </Container>
    )
  }

  return (
    <Container
      display={Container.displays.flex}
      flexDirection={Container.flexDirections.column}
      justifyContent={Container.justifyContentValues.center}
      alignItems={Container.alignItemsValues.center}
      fullWidth>
      {showHeader ? (
        <Container
          py="8"
          layout={Container.layouts.small}
          display={Container.displays.flex}
          alignItems={Container.alignItemsValues.center}
          justifyContent={Container.justifyContentValues.center}>
          <TextTitle heading={TextTitle.headings.h4}>
            {translations.tk_ConfirmationLabel}
          </TextTitle>
        </Container>
      ) : null}
      {questState.template === questDetailTemplates.senryu ? (
        <Post575Component />
      ) : photo ? (
        <Container
          p="4"
          width="64"
          borderColor={Container.borderColors.primary}
          layout={Container.layouts.small}
          display={Container.displays.flex}
          flexDirection={Container.flexDirections.column}
          alignItems={Container.alignItemsValues.center}
          position={Container.positions.relative}>
          <LazyImage
            cover
            width="full"
            height="full"
            src={photo}
            alt="answer-photo"
          />
          {comment ? (
            <Container pt="8">
              <TextBody value={comment} />
            </Container>
          ) : null}
        </Container>
      ) : comment ? (
        <Container
          p="4"
          borderColor={Container.borderColors.primary}
          width="64"
          height="64"
          position={Container.positions.relative}
          layout={Container.layouts.small}
          display={Container.displays.flex}
          alignItems={Container.alignItemsValues.center}
          justifyContent={Container.justifyContentValues.center}>
          <Container
            position={Container.positions.absolute}
            t="0"
            r="0"
            b="0"
            l="0"
            p="4"
            display={Container.displays.flex}
            alignItems={Container.alignItemsValues.center}
            justifyContent={Container.justifyContentValues.center}>
            <LazyImage
              cover
              width="full"
              height="full"
              src={questInfo.commentBackground}
              alt="preview-comment-background"
            />
          </Container>
          <Container zIndex="1" p="4">
            <TextBody value={comment} />
          </Container>
        </Container>
      ) : (
        selects.length &&
        selects.map((s, i) => (
          <Container key={s.id} fullWidth>
            {i ? (
              <Container
                fullWidth
                display={Container.displays.flex}
                justifyContent={Container.justifyContentValues.center}
                pt="4"
                pb="4">
                {translations.tk_and}
              </Container>
            ) : null}
            {s.selections.length > 0 ? (
              <ListContainer columns={1} fullWidth yBetween="4">
                {s.selections.map((selection, index) => (
                  <SelectableOption
                    key={index}
                    option={selection.value}
                    isSelected
                    image={selection.image}
                  />
                ))}
              </ListContainer>
            ) : null}
          </Container>
        ))
      )}
      {submitHandler ? (
        <Container
          display={Container.displays.flex}
          alignItems={Container.alignItemsValues.center}
          pt="8">
          <ListContainer
            fullWidth
            xBetween="8"
            yBetween="4"
            justifyContent={ListContainer.justifyContentValues.center}
            alignItems={ListContainer.alignItemsValues.center}>
            <Link onClickHandler={() => cancelHandler}>
              {translations.tk_previewGoBack}
            </Link>
            <Button
              onClickHandler={submitHandler}
              text={translations.tk_reviewProceed}
            />
          </ListContainer>
        </Container>
      ) : null}
    </Container>
  )
}

export default QuestPreview
